<template>
  <div id="home">
        <router-link to="/about">About</router-link>
    <br/>
    <div class="p-grid p-align-center">
  <div class="p-col"></div>
	<div class="p-col"><img alt="logo" src="../assets/logo.png"></div>
	<div class="p-col">     <router-link tag="Button" to="/login">Log in <i class="pi pi-sign-in p-m-1"></i></router-link><br/>
     <router-link tag="Button" class="p-ml-3 registerbutton" to="/signup">Sign up <i class="pi pi-user-plus p-m-1"></i></router-link></div>
	<div class="p-col"></div>
  </div>
<br/>

    
    <h1>Coming Soon!</h1>
    <p>The <b>Rount Count Application</b> to collect Master Gunner Round Count reports, digitally maintain PDF cards for export, compile CSV formatted file for leverage of Mass Load Capability, maintenance activities, and so much more!</p>
                   <br /> 
                   <p class="details">
                <small class="level-item" style="color: var(--textLight)">
              Brought to you by <b>4/25th Soldier-Coders</b> and SPARwerx
                </small>
              </p>


                <router-link to="/forgot"><small>Forgot Password?</small></router-link>
              <p class="details">
                <small class="level-item" style="color: var(--textLight)">
                  &copy; SPARwerx. All Rights Reserved.
                </small>
              </p>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
};
</script>

<style lang="scss" scoped>
body,
html,
#app {
  background-color: #BB4a4a;
}

#home {
  font-size: 20px;
}

img {
  width: 200px;
}

.registerbutton {
background-color: white;
border-color: white;
}

.registerbutton:enabled:hover, 
.registerbutton:enabled:active {
    background: #a61a27;
    color: white;
    border-color: #a61a27;
}

.registerbutton:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: 0 0 0 0.2rem white;
}
</style>